module.exports = __webpack_public_path__ + "static/media/grayson-music-logo.6c192296.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/grayson-music-logo.svg
// module id = 837
// module chunks = 0